import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Grid, Card, Typography } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import RecapReport from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/Recap';
import {
  StyledCard,
  SpacingTopBottom,
  StyledText,
  SpacingBottom,
} from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/styles';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import warning from 'images/warning.svg';
import {
  MISSION_EXPERISE_VICTIM_STATUS,
  FEE_NOTE_STEP,
} from 'containers/data-structure';

export interface ExpertReportProps {
  intl: IntlShape;
  expertisesVictim: any;
  requestMakeDecisionMissionExpertise: Function;
  claimId: number;
  isLawyer?: boolean;
  feeNotes: any;
  claimNumber: string;
  riskKey: string;
  setOpenFeeNoteDialog: Function;
  isTransaction?: boolean;
  requestGetDocByDocumentumId: Function;
}

const ExpertReport: React.FC<ExpertReportProps> = props => {
  const pendingFeeNote =
    !isEmpty(props.feeNotes) &&
    props.feeNotes.filter(
      (element: any) =>
        (!element.status ||
          element.status === MISSION_EXPERISE_VICTIM_STATUS.PENDING) &&
        (element.step === FEE_NOTE_STEP.EXPERTISE_CONSEIL ||
          element.step === FEE_NOTE_STEP.EXPERTISE_CONSEIL_APPRECIATION),
    ).length;
  return (
    <Grid container direction={'column'} spacing={2}>
      <Grid item style={SpacingTopBottom} xs={7}>
        {pendingFeeNote > 0 && !props.isLawyer && !props.isTransaction ? (
          <Card style={StyledCard} elevation={0}>
            <Grid container direction="row">
              <Grid item xs={1}>
                <img src={warning} alt="warning" />
              </Grid>
              <Grid item>
                <Typography style={StyledText}>
                  {translate({ ...messages.feeNoteWarningTitle }, props, {
                    pendingFeeNote: pendingFeeNote,
                  })}
                </Typography>
              </Grid>
            </Grid>
          </Card>
        ) : (
          <></>
        )}
      </Grid>
      {!isEmpty(props.expertisesVictim) &&
        props.expertisesVictim.map((element: any) => (
          <Grid item style={SpacingBottom}>
            <RecapReport
              recap={{
                ...element,
                victim: get(element, 'mission.victims[0]'),
                victimIncome: get(element, 'victimRevenue'),
                claimId: props.claimId,
              }}
              requestMakeDecisionMissionExpertise={
                props.requestMakeDecisionMissionExpertise
              }
              isLawyer={props.isLawyer}
              claimNumber={props.claimNumber}
              riskKey={props.riskKey}
              setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
              isTransaction={props.isTransaction}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          </Grid>
        ))}
    </Grid>
  );
};
export default injectIntl(ExpertReport);
